module.exports = __webpack_public_path__ + "static/img/xinshoucaozuo.5d414c2f.png";